/* eslint-disable max-classes-per-file */
import { values } from 'lodash';

import { SchemaField } from '../../../../generic/serialization/schema-field';
import { OrgConfigSchema } from '../../generic/org-config/org-config-schema';
import { OrgConfigName } from '../../org-config-name';

import { OperatorAccount } from './operator-account';

export class OrgConfigOperatorSchema extends OrgConfigSchema {
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public static readonly account = 'account';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Constants = class extends OrgConfigSchema.Constants {
    public static readonly docId = OrgConfigName.operator;
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Defaults
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class extends OrgConfigSchema.Defaults {
    public static readonly account = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([OrgConfigOperatorSchema.type, OrgConfigOperatorSchema.account]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();
    parameters[OrgConfigSchema.id] = SchemaField.string(undefined)
      .required()
      .valid(OrgConfigOperatorSchema.Constants.docId);
    parameters[OrgConfigOperatorSchema.type] = SchemaField.string(OrgConfigOperatorSchema.Defaults.type)
      .required()
      .valid(OrgConfigName.operator);
    parameters[OrgConfigOperatorSchema.account] = SchemaField.string(OrgConfigOperatorSchema.Defaults.account)
      .required()
      .valid(...values(OperatorAccount));
    return parameters;
  }
}
